import { Button } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import './index.scss';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className='flex flex-container flex-center not-found'>
      <h1>404</h1>
      <p>Page not found</p>
      <div className='button-group'>
        <Button variant='outlined' onClick={() => navigate(-1)}>
          Back
        </Button>
        <Button
          variant='outlined'
          onClick={() => navigate('/', { replace: true })}
        >
          Home
        </Button>
      </div>
    </div>
  );
};

export default NotFound;
